import { Box, Typography } from '@mui/material';
import React from 'react';

import { SUPPORT_PHONE_DISPLAY, SUPPORT_PHONE_TEL } from '../../../utils/constants';
import { WizardNavigation } from '../WizardNavigation';

/**
 * SessionMissingOrExpiredStep - Fallback screen for missing/expired session
 * 
 * Displayed when required localStorage keys (device serial) are missing
 * or have expired. Provides options to restart the flow or contact support.
 */
export const SessionMissingOrExpiredStep: React.FC = () => {
  const handleRestart = () => {
    // Redirect to the lookup page to start fresh
    window.location.href = '/';
  };

  const handleCallSupport = () => {
    window.open(SUPPORT_PHONE_TEL);
  };

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        p: 3,
      }}
    >
      <Typography variant="h3" component="h1" sx={{ mb: 2 }}>
        {__('Session expired or missing')}
      </Typography>

      <Typography variant="h6" sx={{ mb: 3, color: 'text.secondary' }}>
        {__(
          "We couldn't find your device information. This can happen if your session has expired or you navigated here directly."
        )}
      </Typography>

      <Typography variant="body1" sx={{ mb: 4 }}>
        {__('Please scan the QR code on your device or enter your serial number to start the installation process.')}
      </Typography>

      <WizardNavigation
        primaryLabel={__('Start Over')}
        onPrimary={handleRestart}
        secondaryLabel={`${__('Call Support')}: ${SUPPORT_PHONE_DISPLAY}`}
        onSecondary={handleCallSupport}
      />
    </Box>
  );
};
